import { Component, OnInit, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { cloneDeep, each, findIndex, has } from 'lodash';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { BrigadesService } from './brigades.service';
import { ConfirmModalComponent } from '../../../../../shared/modals/confirm-modal/confirm-modal.component';
import { MergeBrigadeModalComponent } from './modals/merge-brigade-modal/merge-brigade-modal.component';
import { WORK_SHIFT_PATHS } from '../../../work-shift';
import { AuthService } from '../../../../auth/auth.service';
import { PaginationOnLoad } from '../../../../../shared/pagination/pagination';
import { PaginationService } from '../../../../../shared/pagination/pagination.service';
import { Enums } from '../../../../../configs/Enums';
import { AuthGroupTypesEnum } from '../../../../auth/auth-group-types.enum';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-brigades',
  templateUrl: './brigades.component.html',
  styleUrls: ['./brigades.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class BrigadesComponent implements OnInit {
  public stateParams = { brigade_id: '', worker_name: '' };
  public brigadeUnassigned = {
    data: {
      usersList: [],
    },
  };
  public brigadeFilter = {
    data: {
      brigadesList: [],
    },
    brigadeSelected: null,
    brigadeUserName: '',
  };
  public brigadeOperations = {
    brigadesList: [],
  };
  public brigadeTable = {
    isAllBrigadesChecked: false,
    data: {
      brigadesList: [],
    },
    brigadesLoading: false,
  };
  public paginationBlock = {
    limits: [25, 50, 100],
    limitSelected: 25,
    limitCountMaxRows: 0,
    offset: 0,
    countLoaded: 0,
  };
  public brigade_id = null;
  public dataLoading = false;
  public firstLoading = true;
  public filter = { plotSelected: null };
  public isBlockedBrigadeEdit: boolean;

  constructor(
    private authService: AuthService,
    private brigadesService: BrigadesService,
    public modalService: NgbModal,
    private router: Router,
    private route: ActivatedRoute,
    private paginationService: PaginationService
  ) {}

  ngOnInit() {
    this.paginationService.initPagination(this.paginationBlock);
    this.route.parent.paramMap.subscribe((paramMap) => {
      let sectorId = paramMap.get('sector_id');
      if (has(this, 'filter.plotSelected.sector_id') && this.filter.plotSelected.sector_id !== sectorId) {
        this.paginationBlock.offset = 0;
        this.brigadeTable.data.brigadesList = [];
      }

      this.filter.plotSelected = { sector_id: sectorId || null };

      if (!this.firstLoading) {
        // this.onUpdateWidget();
      }
    });

    this.route.params.subscribe((params) => {
      let countParameters = 0;
      let countExistsParameters = 0;

      this.stateParams.brigade_id = params['brigade_id'] || '';
      this.stateParams.worker_name = params['worker_name'] || '';

      each(this.stateParams, function (value, key) {
        countParameters++;

        if (has(params, [key])) {
          countExistsParameters++;
        }
      });

      this.checkInitFilter();

      if (countParameters === countExistsParameters) {
        this.paginationService.updatePaginationLoadPartial(0, 0);
        this.onUpdateWidget(false);
      } else {
        this.router.navigate(
          [WORK_SHIFT_PATHS.work_shift, WORK_SHIFT_PATHS.work_shift_s, this.filter.plotSelected.sector_id, WORK_SHIFT_PATHS.work_shift_brigades, this.stateParams],
          {
            replaceUrl: true,
          }
        );
      }
    });

    this.isBlockedBrigadeEdit = !this.authService.checkPermission('brigade.edit');
  }

  private makeBrigadesParams(isUpdate) {
    return {
      sector_id: this.filter.plotSelected.sector_id,
      offset: isUpdate ? 0 : this.paginationBlock.offset,
      limit: this.paginationBlock.limitSelected,
      brigade_id: this.brigade_id || (this.brigadeFilter.brigadeSelected && this.brigadeFilter.brigadeSelected.id) || this.stateParams.brigade_id || '',
      worker_name: this.brigadeFilter.brigadeUserName || '',
      groups: this.authService.isGRSUser()
        ? [AuthGroupTypesEnum.DispatcherGRS, AuthGroupTypesEnum.ServiceEngineerGRS]
        : [AuthGroupTypesEnum.Admin, AuthGroupTypesEnum.Curator, AuthGroupTypesEnum.Dispatcher, AuthGroupTypesEnum.ServiceEngineer],
    };
  }

  private getUnionBrigades(isUpdate) {
    if (this.dataLoading) {
      return;
    }

    const sectorParams = {
      sector_id: this.filter.plotSelected.sector_id,
      groups: this.authService.isGRSUser()
        ? [AuthGroupTypesEnum.ServiceEngineerGRS]
        : [AuthGroupTypesEnum.Admin, AuthGroupTypesEnum.Curator, AuthGroupTypesEnum.Dispatcher, AuthGroupTypesEnum.ServiceEngineer],
    };

    const brigadesParams = this.makeBrigadesParams(isUpdate);
    this.dataLoading = true;
    this.brigadesService.getUnionBrigades(sectorParams, brigadesParams).subscribe(
      (response) => {
        this.brigadeUnassigned.data.usersList = response[0]['data'];
        this.brigadeFilter.data.brigadesList = response[1]['data'];
        this.setDefaultChecked(response[2]['data']);
        this.setBrigades(response[2]['data']);
        this.updatePartial(response[2]['data']);
        this.checkInitFilter();

        this.firstLoading = false;
        this.dataLoading = false;
      },
      (error) => {
        console.log(error);
        this.dataLoading = false;
      }
    );
  }

  private getBrigades() {
    this.brigadeTable.brigadesLoading = true;
    this.brigadesService.getBrigades(this.makeBrigadesParams(false)).subscribe(
      (response) => {
        let resp = response['data'];

        this.setDefaultChecked(resp);
        this.setBrigades(resp);
        this.updatePartial(resp);

        this.firstLoading = false;
        this.brigadeTable.brigadesLoading = false;
      },
      (error) => {
        this.brigadeTable.brigadesLoading = false;
        console.log(error);
      }
    );
  }

  private checkInitFilter() {
    if (this.stateParams.brigade_id) {
      let brigadeIndex = findIndex(this.brigadeTable.data.brigadesList, (b) => b.id === +this.stateParams.brigade_id);

      if (brigadeIndex > -1) {
        this.brigadeFilter.brigadeSelected = this.brigadeTable.data.brigadesList[brigadeIndex];
      }
    } else {
      this.brigadeFilter.brigadeSelected = null;
    }

    this.brigadeFilter.brigadeUserName = this.stateParams.worker_name || '';
  }

  private setDefaultChecked(response) {
    response.results.map((brigade) => {
      brigade.is_checked = false;
      return brigade;
    });
  }

  private setBrigades(response) {
    this.brigadeTable.data.brigadesList = this.brigadeTable.data.brigadesList.concat(response.results);
  }

  private updatePartial(response) {
    this.paginationService.updatePaginationLoadPartial(this.brigadeTable.data.brigadesList.length, response['count']);
  }

  public onUpdateWidget(isUpdate) {
    this.brigadeUnassigned.data.usersList = [];
    this.brigadeFilter.data.brigadesList = [];
    this.brigadeOperations.brigadesList = [];
    this.brigadeTable.data.brigadesList = [];
    this.getUnionBrigades(isUpdate);
  }

  public onChangeSelectedBrigade(brigadeSelected) {
    this.brigadeFilter.brigadeSelected = brigadeSelected || null;
  }

  public onChangeAllBrigadesState(isChecked) {
    this.brigadeTable.isAllBrigadesChecked = isChecked;
    this.brigadeTable.data.brigadesList.forEach((brigade) => {
      this.onChangeBrigadeState(isChecked, brigade);
    });
  }

  public onChangeBrigadeState(isChecked, brigade) {
    let brigadeIndex = findIndex(this.brigadeOperations.brigadesList, {
      id: brigade.id,
    });

    if (isChecked && brigadeIndex === -1) {
      brigade.is_checked = true;
      this.brigadeOperations.brigadesList.push(brigade);
    }

    if (!isChecked && brigadeIndex > -1) {
      brigade.is_checked = false;
      this.brigadeOperations.brigadesList.splice(brigadeIndex, 1);
    }

    if (this.brigadeOperations.brigadesList && !this.brigadeOperations.brigadesList.length) {
      this.brigadeTable.isAllBrigadesChecked = false;
    }
  }

  public onApplyFilter() {
    this.paginationBlock.offset = 0;
    this.brigadeTable.data.brigadesList = [];

    this.router.navigate([
      WORK_SHIFT_PATHS.work_shift,
      WORK_SHIFT_PATHS.work_shift_s,
      this.filter.plotSelected.sector_id,
      WORK_SHIFT_PATHS.work_shift_brigades,
      {
        brigade_id: (this.brigadeFilter.brigadeSelected && this.brigadeFilter.brigadeSelected.id) || '',
        worker_name: this.brigadeFilter.brigadeUserName || '',
      },
    ]);
    // this.getBrigades();
  }

  public onResetFilter() {
    this.brigadeFilter.brigadeSelected = null;
    this.brigadeFilter.brigadeUserName = '';
    this.paginationBlock.offset = 0;
    this.brigadeTable.data.brigadesList = [];
    this.brigade_id = null;
    this.brigadeFilter.brigadeUserName = '';

    if (!this.stateParams.brigade_id && !this.stateParams.worker_name) {
      this.paginationService.updatePaginationLoadPartial(0, 0);
      this.getBrigades();
    } else {
      this.router.navigate([
        WORK_SHIFT_PATHS.work_shift,
        WORK_SHIFT_PATHS.work_shift_s,
        this.filter.plotSelected.sector_id,
        WORK_SHIFT_PATHS.work_shift_brigades,
        { brigade_id: '', worker_name: '' },
      ]);
    }
  }

  public onOpenDisbandmentConfirmDialog() {
    const fixedPlanedScheduleConfirmDialog = this.modalService.open(ConfirmModalComponent, {
      ariaLabelledBy: 'modal-basic-title',
      windowClass: 'modal-wrapper',
      backdrop: 'static',
    });
    let brigadesName = [];

    this.brigadeOperations.brigadesList.forEach((brigade) => {
      brigadesName.push(brigade.brigade_name);
    });

    fixedPlanedScheduleConfirmDialog.componentInstance.title = 'Расформирование бригад' + (this.brigadeOperations.brigadesList.length > 1 ? '' : 'ы');
    fixedPlanedScheduleConfirmDialog.componentInstance.description =
      'Бригад' +
      (this.brigadeOperations.brigadesList.length > 1 ? 'ы' : 'а') +
      ' "' +
      brigadesName.join(', ') +
      '" буд' +
      (this.brigadeOperations.brigadesList.length > 1 ? 'ут' : 'ет') +
      ' расформирован' +
      (this.brigadeOperations.brigadesList.length > 1 ? 'ы' : 'а') +
      '. Заявки, назначенные на бригад' +
      (this.brigadeOperations.brigadesList.length > 1 ? 'ы' : 'у') +
      ', будут переведены в статус “Нe отправлена”. Вы уверены, что хотите это сделать?';
    fixedPlanedScheduleConfirmDialog.componentInstance.successButtonName = 'Да, расформировать';
    fixedPlanedScheduleConfirmDialog.componentInstance.abortButtonName = 'Отмена';
    fixedPlanedScheduleConfirmDialog.componentInstance.successCallbackAction = this.brigadeDisbandment.bind(this);
    fixedPlanedScheduleConfirmDialog.componentInstance.errorMessageCode = Enums.errorCodesMaps['BACKEND_ERROR'];

    fixedPlanedScheduleConfirmDialog.result.then(
      () => {
        this.brigadeTable.isAllBrigadesChecked = false;
        this.onUpdateWidget(false);
      },
      () => {}
    );
  }

  public onOpenMergeDialog() {
    const mergeBrigadeModal = this.modalService.open(MergeBrigadeModalComponent, {
      ariaLabelledBy: 'modal-basic-title',
      windowClass: 'modal-wrapper',
      backdrop: 'static',
    });

    mergeBrigadeModal.componentInstance.brigadesList = cloneDeep(this.brigadeOperations.brigadesList);

    mergeBrigadeModal.result.then(
      () => {
        this.brigadeTable.isAllBrigadesChecked = false;
        this.onUpdateWidget(false);
      },
      () => {}
    );
  }

  public brigadeDisbandment() {
    const brigade_ids = this.brigadeOperations.brigadesList.map((brigade) => brigade.id);

    return this.brigadesService.brigadeDisbandment({
      brigade_ids: brigade_ids,
    });
  }

  onLoadPartial(paginationLoad: PaginationOnLoad): void {
    this.getBrigades();
  }
}
